var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserDashboardStatisticsCard2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 190,
  height: 168,
  viewBox: "0 0 190 168",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 33.2871,
  y: 9.94547,
  width: 143.049,
  height: 141.145,
  rx: 5,
  fill: "#E7EAF1"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M107.301 151.152L107.652 124.732C107.409 122.28 107.099 119.899 106.798 117.581C105.54 107.915 104.423 99.3365 108.907 91.1781L110.631 74.0347L147.921 75.0637L166.823 77.1484C174.996 78.8051 175.479 117.233 172.186 151.049L114.144 151.152C109.256 151.152 107.301 151.152 107.301 151.152Z",
  fill: "#79A342"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M110.632 74.0294C106.084 73.9596 98.8001 82.2087 92.2135 94.6782L59.9949 130.814C60.657 140.685 64.9784 145.114 72.6802 144.521C77.6637 144.138 82.2813 141.801 85.6269 138.086L115.859 104.584L110.632 74.0294Z",
  fill: "#F7A88F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M110.631 74.0297C106.745 72.7741 100.873 79.0175 91.6903 93.7368C88.4493 98.9165 87.8394 98.7769 80.2944 107.2L98.8345 127.535L118.263 105.805L110.631 74.0297Z",
  fill: "#79A342"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M117.985 60.0946C119.431 61.1235 121.191 61.6293 122.951 61.9432C127.046 61.9781 131.733 60.4957 136.682 58.4029C141.91 56.1706 146.109 51.985 148.165 46.6833C152.574 35.3474 144.959 25.895 133.458 25.6857C127.342 25.581 121.418 27.2901 118.7 32.4175C118.456 32.8709 117.776 34.6323 117.637 35.016C116.94 37.1262 116.417 39.3062 116.051 41.5036C115.215 46.6659 112.845 56.4322 117.985 60.0946Z",
  fill: "#F7A88F"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M141.369 53.4C142.153 63.6372 143.391 69.7237 146.231 75.008L123.248 74.851L121.191 61.2305L141.369 53.4Z",
  fill: "#F7A88F"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M125.34 49.8955C125.428 49.7733 125.532 49.6512 125.602 49.5116C125.811 49.1801 126.003 48.7963 126.003 48.395C126.003 47.9937 125.759 47.5749 125.375 47.4702C125.114 47.4005 124.817 47.4877 124.556 47.5749C123.667 47.889 119.657 49.1976 119.989 50.5236C120.215 51.4483 122.464 51.6402 123.179 51.4308C124.05 51.1866 124.8 50.6108 125.34 49.8955Z",
  fill: "white"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M138.668 54.3754C139.626 56.7995 140.236 59.0667 142.153 60.8281C143.826 56.5379 146.596 52.0733 148.809 48.0273C149.959 45.9519 151.005 44.3126 151.702 42.0628C152.468 39.6212 152.974 37.1622 152.625 34.5986C152.364 32.6627 151.58 30.7618 150.325 29.2445C149.454 28.1981 148.182 27.7272 147.154 26.9076C145.934 25.9309 144.889 24.7625 143.599 23.873C140.741 21.9198 137.152 21.257 133.702 21.3617C130.356 21.4663 126.923 22.1639 123.7 23.0533C122.463 23.3847 118.891 24.5881 118.699 26.1576C118.629 26.6634 119.309 26.925 119.814 26.8552C120.319 26.7855 120.86 26.5762 121.295 26.8378C120.285 27.6052 119.274 28.3551 118.246 29.1224C117.95 29.3491 117.636 29.6282 117.671 29.9944C117.706 30.4304 118.211 30.6223 118.629 30.7269C121.644 31.4419 124.832 31.3896 127.83 30.6048C127.359 30.7269 124.937 32.157 124.885 32.6627C124.693 34.5637 135.061 34.1277 136.49 34.1102C136.437 37.8424 134.59 40.9118 134.364 44.5567C134.312 45.4287 134.399 46.4577 135.148 46.9111C135.706 47.2425 136.42 47.1204 137.047 46.9809C137.065 47.0157 137.709 51.9512 138.668 54.3754Z",
  fill: "#122057"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M121.191 74.4479L121.575 75.3199C124.763 82.4877 133.615 85.0514 140.132 80.7089L148.113 75.3897C148.043 75.2851 147.973 75.163 147.904 75.0583L121.261 74.3259C121.244 74.3782 121.226 74.3956 121.191 74.4479Z",
  fill: "#F7A88F"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M60.4405 136.495L52.1465 94.0265L71.4513 91.6513L85.1699 132.6L60.4405 136.495Z",
  fill: "#F7A88F"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3955 65.2336C36.3331 63.6336 36.3139 61.9993 36.7309 60.461C36.8514 60.0194 37.0245 59.5288 37.4278 59.2916C38.1095 58.8817 38.9812 59.4269 39.4241 60.0887C40.1769 61.2012 40.2903 62.6264 40.3738 63.9698C40.5854 67.1637 41.15 70.3581 41.3616 73.5521C41.0555 68.9036 40.8992 64.2485 40.9073 59.5961C40.9027 57.9712 40.9645 56.244 41.877 54.9026C42.224 54.4002 42.7551 53.934 43.3645 53.9554C43.9351 53.9724 44.4284 54.3966 44.7003 54.9058C44.9722 55.415 45.0322 55.9946 45.1017 56.5596C45.6818 61.4899 46.3606 66.1723 46.6557 71.1256C46.3152 66.0181 46.1874 60.9032 46.2867 55.7903C46.3041 54.8035 46.35 53.7728 46.7941 52.8968C47.2529 52.0302 48.2552 51.3502 49.2059 51.6139C49.8752 51.7989 50.3802 52.3971 50.62 53.0518C50.8597 53.7065 50.8971 54.4169 50.9052 55.1084C51.0549 59.6137 51.2046 64.119 51.3639 68.6097L51.3455 67.87C51.3274 64.2819 51.3145 60.7179 51.2964 57.1298C51.2876 56.3755 51.2882 55.6065 51.5701 54.9162C51.852 54.226 52.4928 53.6231 53.2468 53.6136C53.9768 53.6093 54.5972 54.1576 55.0006 54.7522C56.1275 56.4404 56.076 58.6318 56.0902 60.6579C56.1226 62.5919 56.242 64.52 56.487 66.4465C56.5668 67.0597 56.656 67.6582 56.8899 68.2259C57.2232 69.0245 57.84 69.6745 58.437 70.2908C59.7291 71.6287 61.0262 72.9907 62.3182 74.3285C62.522 73.5667 62.5847 72.7341 62.5561 71.9462C62.4857 70.4866 62.1545 69.0448 61.9731 67.5963C61.7683 65.7998 61.8389 63.9951 62.1806 62.2208C62.3171 61.4985 62.5545 60.7169 63.1784 60.3319C63.9799 59.8334 65.0825 60.2789 65.657 61.0261C66.2314 61.7733 66.4215 62.7285 66.616 63.6449C67.2236 66.389 68.1395 69.0421 69.3199 71.5759C69.8257 72.6528 70.3943 73.729 70.6882 74.8762C70.9463 75.8547 70.9873 76.8794 70.9992 77.8852C71.061 80.67 70.9342 83.4571 70.6526 86.2269L71.8776 93.7799L52.1603 93.9745C48.2835 90.3139 44.5025 86.57 40.793 82.7477C39.8584 81.7874 38.9186 80.803 38.3149 79.6209C37.1374 77.3386 37.6938 74.9136 37.1484 72.5217C36.6366 70.1101 36.4828 67.7231 36.3955 65.2336Z",
  fill: "#F7A88F"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3621 73.5546C50.9558 78.2653 57.9156 83.865 60.5953 90.9693",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M121.243 61.5629C124.728 62.1558 129.886 60.6211 135.723 58.2144C130.687 62.7139 125.983 65.9403 121.992 66.5507L121.243 61.5629Z",
  fill: "#E5766A"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M107.025 119.374C104.15 111.909 106.38 101.602 108.907 91.1558",
  stroke: "#78A242",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M140.268 53.9957C143.858 53.9957 146.768 51.0855 146.768 47.4957C146.768 43.9058 143.858 40.9957 140.268 40.9957C136.678 40.9957 133.768 43.9058 133.768 47.4957C133.768 51.0855 136.678 53.9957 140.268 53.9957Z",
  fill: "#F7A88F"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M165.796 138.212L169.765 124.036L144.859 117.722L132.939 151.064H162.304C162.671 149.89 165.56 139.259 165.796 138.212Z",
  fill: "#F7A88F"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M148.543 104.631L140.254 127.543",
  stroke: "#70B46C",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 56.5266,
  height: 77.6027,
  rx: 3,
  transform: "matrix(-1 0 0 1 62.1392 43.816)",
  fill: "#233D4D"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M51.3877 54.015L54.6982 53.9976L54.7172 57.6168L51.4067 57.6341L51.3877 54.015Z",
  stroke: "#E7EAF1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8956 54.0776L48.3315 54.0386L48.3505 57.6578L40.9145 57.6968L40.8956 54.0776Z",
  stroke: "#E7EAF1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1509 54.1625L37.1011 54.1051L37.12 57.7242L26.1698 57.7816L26.1509 54.1625Z",
  stroke: "#E7EAF1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7029 54.2031L24.2407 54.1636L24.2597 57.7828L16.7219 57.8223L16.7029 54.2031Z",
  stroke: "#E7EAF1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M51.439 63.3431L54.7495 63.3257L54.7684 66.9449L51.4579 66.9623L51.439 63.3431Z",
  stroke: "#E7EAF1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1054 63.46L48.3828 63.3589L48.4018 66.9781L29.1243 67.0792L29.1054 63.46Z",
  stroke: "#E7EAF1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2468 63.5451L24.292 63.482L24.3109 67.1012L12.2657 67.1643L12.2468 63.5451Z",
  stroke: "#E7EAF1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M62.333 74.3414C60.5859 78.6964 60.8386 82.9151 63.0868 87.0363",
  stroke: "#F7A88F",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.1
}, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M110.947 140.908L111.233 140.501L137.39 139.893L148.876 98.7416L140.61 98.7416L111.233 140.501L110.421 140.52L72.0902 112.329L72.6624 120.613L93.7683 140.908L110.421 140.52L110.947 140.908Z",
  fill: "url(#paint0_linear_1508_35611)"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.1
}, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M168.87 100.832L149.075 138.315L159.897 151.049L172.101 151.049L175.891 99.9342L168.87 100.832Z",
  fill: "url(#paint1_linear_1508_35611)"
}))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M151.807 89.6338C151.807 89.6338 158.275 80.2292 161.027 78.5974C165.13 76.9412 168.357 76.431 174.146 80.3071C180.704 85.9675 179.325 94.9429 178.997 101.15C178.919 102.483 178.768 103.818 178.508 105.15L178.157 106.545L173.37 133.615L140.552 128.566L151.807 89.6338Z",
  fill: "#79A342"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M123.545 38.8648L122.766 43.199C120.693 42.8668 119.582 43.2322 121.986 46.1382",
  stroke: "#F76D6D",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M128.022 43.291C127.374 43.1363 127.017 42.3111 127.223 41.4478C127.429 40.5846 128.121 40.0102 128.769 40.1648C129.416 40.3195 129.774 41.1447 129.568 42.008C129.361 42.8712 128.669 43.4457 128.022 43.291Z",
  fill: "#232F55"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M118.327 41.2388C117.666 41.1621 117.213 40.3852 117.315 39.5035C117.418 38.6219 118.037 37.9694 118.698 38.0461C119.359 38.1229 119.812 38.8998 119.71 39.7815C119.607 40.6631 118.988 41.3156 118.327 41.2388Z",
  fill: "#232F55"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M44.7638 98.0591C50.6119 98.1743 55.4459 93.5293 55.5607 87.6841C55.6756 81.839 51.0278 77.0071 45.1797 76.8918C39.3316 76.7766 34.4977 81.4216 34.3829 87.2668C34.268 93.112 38.9157 97.9438 44.7638 98.0591Z",
  fill: "#79A342"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9765 91.9897L45.1859 92.2068L45.3604 91.9607L56.9078 75.6779L56.9088 75.6764C57.0868 75.4215 57.0412 75.0493 56.7706 74.8606C56.516 74.6831 56.1444 74.7283 55.9554 74.998C55.9552 74.9983 55.955 74.9986 55.9548 74.9989L45.0396 90.3818L42.0058 87.2332C41.7776 86.9913 41.405 87.0126 41.1845 87.2189C40.9408 87.4469 40.9617 87.8206 41.1687 88.0415L41.1686 88.0415L41.1712 88.0441L44.9765 91.9897Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1508_35611",
  x1: 125.834,
  y1: 99.9612,
  x2: 78.9043,
  y2: 153.14,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.148362,
  stopColor: "#384272"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1508_35611",
  x1: 154.369,
  y1: 103.916,
  x2: 114.563,
  y2: 162.617,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.148362,
  stopColor: "#384272"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserDashboardStatisticsCard2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/userDashboard-statistics-card2.8a4ed703a69b5423627f6b382783b1db.svg";